// Copyright (c) 2025 Comsearch, Inc., All rights reserved

import { BandIdEnum } from 'config/enums'

const isEBandPath = (bandId) => (
  bandId == BandIdEnum.E_BAND
)

export default isEBandPath
